import $ from 'jquery';
import { FIRST_NAME, LAST_NAME } from '../config/index';

if ($('.site-header .my-account').length) {
  $('.site-header .my-account > a')
    .contents()
    .filter(function () {
      return this.nodeType == 3;
    })[0].nodeValue = `${FIRST_NAME} ${LAST_NAME}`;
}

if ($('.mobile-nav .my-account').length) {
  $('.mobile-nav .my-account > a').append('<i class="icon-user"></i>');
}
